import { FaBook } from "react-icons/fa";
import { ManualsViewMain } from "../Components/ManualsViewMain";
import { ManualDetailViewMain } from "../Components/ManualDetailViewMain";

export const ManualsModule = (DATA_USER_AUTH = null) => [
    {
        views: "PRIVATE", path: "/manuals/:id", component: <ManualDetailViewMain />,
        roles: null, permissions: null, label: "Detalle de manual", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/manuals", component: <ManualsViewMain />,
        roles: null, permissions: null, label: "Manuales", icon: <FaBook />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true,
        isBlockedWhenLogged: false,
    },
];
